import React, { useState } from "react";

interface PasswordFormUIProps {
  title?: string;
  buttonLabel?: string;
  loading: boolean;
  error: string | null;
  onSubmit: (password: string, confirmPassword: string) => void;
}

export default function PasswordFormUI({
  title = "Set Your Password",
  buttonLabel = "Save Password",
  loading,
  error,
  onSubmit,
}: PasswordFormUIProps) {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  return (
    <div className="mt-4">
      {/* Heading */}
      <h1 className="text-dark-text text-[20px] font-medium">{title}</h1>

      <p className="mt-2 font-normal text-dark-text text-[12px]">
        Please enter a strong password for your account.
      </p>

      {/* PASSWORD INPUT */}
      <div className="mt-4">
        <label className="block text-white font-medium text-primary">
          New Password
        </label>

        <input
          type="password"
          disabled={loading}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className={`mt-2 block w-full rounded-xl border-0 ring-1 ring-inset ring-dark-border 
            !placeholder:text-dark-text !bg-dark-background-secondary-medium 
            px-3 py-2 !text-white !caret-white !outline-none !focus:outline-none 
            focus:ring-2 !focus:ring-white disabled:opacity-50 disabled:cursor-not-allowed`}
          placeholder="Enter your new password"
          required
        />
      </div>

      {/* CONFIRM PASSWORD INPUT */}
      <div className="mt-4">
        <label className="block text-white font-medium text-primary">
          Confirm Password
        </label>

        <input
          type="password"
          disabled={loading}
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className={`mt-2 block w-full rounded-xl border-0 ring-1 ring-inset ring-dark-border 
            !placeholder:text-dark-text !bg-dark-background-secondary-medium 
            px-3 py-2 !text-white !caret-white !outline-none !focus:outline-none 
            focus:ring-2 !focus:ring-white disabled:opacity-50 disabled:cursor-not-allowed`}
          placeholder="Re-enter your password"
          required
        />
      </div>

      {/* ERROR MESSAGE */}
      {error && (
        <p className="mt-2 text-sm text-red-500 font-medium">{error}</p>
      )}

      {/* SUBMIT BUTTON */}
      <button
        type="submit"
        onClick={() => onSubmit(password, confirmPassword)}
        disabled={loading}
        className="mt-6 w-full rounded-xl bg-indigo-600 px-4 py-2.5 
                   text-white text-sm font-medium hover:bg-indigo-700 
                   disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {loading ? "Processing..." : buttonLabel}
      </button>
    </div>
  );
}
